import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MediaDownloadService} from '@core/interfaces/common/media-download';
import {HttpService} from '@core/backend/common/api/http.service';

@Injectable()
export class MediaDownloadServiceImpl extends MediaDownloadService {
    constructor(private api: HttpService) {
        super();
    }

    public fetchBlob(url: string): Observable<Blob> {
        return this.api.downloadS3(url);
    }
}
